// Texto de un correo con sus imagenes pegadas en el lugar donde iban (en vez de "[image: image.png]").
import type { ReactNode } from 'react';

import type { AdjuntoRecibido } from '../api/correo';
import { MARCA_IMAGEN, ubicarImagenes } from '../lib/imagenesEnLinea';
import { esImagen, Miniatura } from './AdjuntosCorreo';
import { ConEnlaces } from './Conversacion';

export type ImagenesDe = { lista: AdjuntoRecibido[]; traer: (a: AdjuntoRecibido) => Promise<Blob>; clave: string };

export function TextoConImagenes({ texto, imagenes }: { texto: string; imagenes?: ImagenesDe | null }) {
  const lista = (imagenes?.lista ?? []).filter(esImagen);
  if (!imagenes || !lista.length) return <ConEnlaces texto={texto} />;
  const ubicadas = ubicarImagenes(texto, lista);
  const partes: ReactNode[] = [];
  let desde = 0;
  [...texto.matchAll(MARCA_IMAGEN)].forEach((m, i) => {
    const a = ubicadas[i];
    if (!a) return;
    const en = m.index ?? 0;
    // El salto de linea que rodea la marca lo pone la imagen (es un bloque).
    partes.push(<ConEnlaces key={`t${en}`} texto={texto.slice(desde, en).replace(/\n$/, '')} />);
    partes.push(<Miniatura key={`i${a.parte}`} mensajeId={imagenes.clave} a={a} traer={imagenes.traer} enLinea />);
    desde = en + m[0].length;
    if (texto[desde] === '\n') desde += 1;
  });
  partes.push(<ConEnlaces key="fin" texto={texto.slice(desde)} />);
  return <>{partes}</>;
}
